// removed by extract-text-webpack-plugin
module.exports = {"mainContainer":"_1PGLc56FIoR9dRfljC8Eps"};


//////////////////
// WEBPACK FOOTER
// ./src/ui-modules/sports-book/css/resultCard.css
// module id = 781
// module chunks = 0